import { render, staticRenderFns } from "./send-confirm.vue?vue&type=template&id=32d89064&scoped=true"
import script from "./send-confirm.vue?vue&type=script&lang=js"
export * from "./send-confirm.vue?vue&type=script&lang=js"
import style0 from "./send-confirm.vue?vue&type=style&index=0&id=32d89064&prod&lang=scss&scoped=true"
import style1 from "./send-confirm.vue?vue&type=style&index=1&id=32d89064&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d89064",
  null
  
)

export default component.exports